import type * as THREE from "three";
import { Polyline } from "@designboticteam/workspace-3d";

class BuildingLine extends Polyline {
	constructor({
		lineColor,
		labelColor,
		vertexHandlesColor,
		vertexHandlesFillColor,
		vertexHandlesHighlightColor,
	}: {
		lineColor: THREE.ColorRepresentation;
		labelColor: THREE.ColorRepresentation;
		vertexHandlesColor: THREE.ColorRepresentation;
		vertexHandlesFillColor: THREE.ColorRepresentation;
		vertexHandlesHighlightColor: THREE.ColorRepresentation;
	}) {
		super({
			label: "Building line",
			lineColor,
			labelColor,
			vertexHandlesColor,
			vertexHandlesFillColor,
			vertexHandlesHighlightColor,
		});
	}
}

export { BuildingLine };
